// src/hooks/useCurrency.js
// Central hook — reads secondary currency config from settings.
// Use this everywhere instead of hardcoding "LBP" or "ل.ل".
//
// Usage:
//   const { showSec, secCode, secSymbol, rate, fmtSec, fmtUSD } = useCurrency();
//
// showSec   — boolean: show secondary currency column/field
// secCode   — string:  "LBP" | "EUR" | "AED" | ...
// secSymbol — string:  "ل.ل" | "€"   | "د.إ" | ...
// rate      — number:  units of secondary per 1 USD
// fmtSec(n) — format a number as secondary currency string
// fmtUSD(n) — format a number as USD string

import { useQuery } from '@tanstack/react-query';
import api from '../config/api';

export default function useCurrency() {
  const { data: settings } = useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get('/api/settings').then(r => r.data),
  });

  const showSec   = settings?.currency?.show_lbp ?? true;
  const secCode   = settings?.currency?.secondary_code   || 'LBP';
  const secSymbol = settings?.currency?.secondary_symbol || 'ل.ل';
  const rate      = Number(settings?.exchange_rate) || 89500;

  const fmtSec = (n) => `${secSymbol} ${Math.round(Number(n || 0)).toLocaleString('en-US')}`;
  const fmtUSD = (n) => `$${Number(n || 0).toFixed(2)}`;

  return { showSec, secCode, secSymbol, rate, fmtSec, fmtUSD };
}